/**
 * bootAbilitySfx — Wire procedural ability SFX + __debugAbilitySfx (SPY-111).
 */
import { createAbilitySfxPlayer } from './audio/abilitySfxPlayer.js';

function resolveAudioContext() {
  const AC = globalThis.AudioContext || globalThis.webkitAudioContext;
  if (!AC) return null;
  if (!globalThis.__lolAbilityAudioCtx) {
    globalThis.__lolAbilityAudioCtx = new AC();
  }
  return globalThis.__lolAbilityAudioCtx;
}

/**
 * @param {object} [globalObj]
 * @param {Parameters<typeof createAbilitySfxPlayer>[0]} [playerDeps]
 * @returns {ReturnType<typeof createAbilitySfxPlayer>}
 */
export function bootAbilitySfx(globalObj = globalThis, playerDeps = {}) {
  const abilitySfx = createAbilitySfxPlayer({
    getContext: resolveAudioContext,
    getVolumeScale: () => {
      const s = globalObj?.__debugSettings?.get?.();
      if (!s) return 1;
      return (s.masterVolume ?? 1) * (s.sfxVolume ?? 1);
    },
    ...playerDeps
  });
  if (globalObj) {
    globalObj.__debugAbilitySfx = {
      playCast: (id) => abilitySfx.playCast(id),
      playHit: (id) => abilitySfx.playHit(id),
      playForCastResult: (id, kind) => abilitySfx.playForCastResult(id, kind)
    };
  }
  return abilitySfx;
}
